/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  CurrentLegalDocumentsResponseV1,
  CursorPaginatedLegalAcceptanceResponseV1,
  CursorPaginatedLegalDocumentResponseV1,
  LegalAcceptanceCreateRequestV1Request,
  LegalAcceptanceResponseV1,
  LegalAcceptanceStatusResponseV1,
  LegalDocumentCreateRequestV1Request,
  LegalDocumentResponseV1,
  LegalV1AcceptancesListParams,
  LegalV1DocumentsListParams
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class LegalService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. Newest first; `?user_id=` narrows to one client. The proof before the Agency.
 * @summary List the acceptances of the legal documents (cursor-paginated).
 */
 legalV1AcceptancesList<TData = CursorPaginatedLegalAcceptanceResponseV1>(params?: LegalV1AcceptancesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 legalV1AcceptancesList<TData = CursorPaginatedLegalAcceptanceResponseV1>(params?: LegalV1AcceptancesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 legalV1AcceptancesList<TData = CursorPaginatedLegalAcceptanceResponseV1>(params?: LegalV1AcceptancesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  legalV1AcceptancesList<TData = CursorPaginatedLegalAcceptanceResponseV1>(
    params?: LegalV1AcceptancesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/legal/acceptances/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/legal/acceptances/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/legal/acceptances/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Regular users only. One checkbox, one row: the two versions the client saw, the time and their IP. An acceptance is never edited nor deleted (S-acc-6). Idempotent: accepting the same versions again returns the first acceptance with 200.
 * @summary Accept the current terms of service and privacy policy.
 */
 legalV1AcceptancesCreate<TData = LegalAcceptanceResponseV1>(legalAcceptanceCreateRequestV1Request: LegalAcceptanceCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 legalV1AcceptancesCreate<TData = LegalAcceptanceResponseV1>(legalAcceptanceCreateRequestV1Request: LegalAcceptanceCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 legalV1AcceptancesCreate<TData = LegalAcceptanceResponseV1>(legalAcceptanceCreateRequestV1Request: LegalAcceptanceCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  legalV1AcceptancesCreate<TData = LegalAcceptanceResponseV1>(
    legalAcceptanceCreateRequestV1Request: LegalAcceptanceCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/legal/acceptances/`,
      legalAcceptanceCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/legal/acceptances/`,
      legalAcceptanceCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/legal/acceptances/`,
      legalAcceptanceCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Regular users only. Same shape as `GET /v4/accounts/users/me/profile/status/`: the front shows the acceptance screen while `pending` is true.
 * @summary Whether the authenticated client still has to accept the current documents.
 */
 legalV1AcceptancesStatusRetrieve<TData = LegalAcceptanceStatusResponseV1>( options?: HttpClientBodyOptions): Observable<TData>;
 legalV1AcceptancesStatusRetrieve<TData = LegalAcceptanceStatusResponseV1>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 legalV1AcceptancesStatusRetrieve<TData = LegalAcceptanceStatusResponseV1>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  legalV1AcceptancesStatusRetrieve<TData = LegalAcceptanceStatusResponseV1>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/legal/acceptances/status/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/legal/acceptances/status/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/legal/acceptances/status/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Newest first; `?kind=` narrows to one document.
 * @summary List every version of the legal documents (cursor-paginated).
 */
 legalV1DocumentsList<TData = CursorPaginatedLegalDocumentResponseV1>(params?: LegalV1DocumentsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 legalV1DocumentsList<TData = CursorPaginatedLegalDocumentResponseV1>(params?: LegalV1DocumentsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 legalV1DocumentsList<TData = CursorPaginatedLegalDocumentResponseV1>(params?: LegalV1DocumentsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  legalV1DocumentsList<TData = CursorPaginatedLegalDocumentResponseV1>(
    params?: LegalV1DocumentsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/legal/documents/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/legal/documents/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/legal/documents/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. The version is the next number of its kind and is current at once: every client is asked to accept it on their next access (S-acc-6). A version is never edited nor deleted, so show a preview and ask for confirmation before posting.
 * @summary Publish the next version of a legal document.
 */
 legalV1DocumentsCreate<TData = LegalDocumentResponseV1>(legalDocumentCreateRequestV1Request: LegalDocumentCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 legalV1DocumentsCreate<TData = LegalDocumentResponseV1>(legalDocumentCreateRequestV1Request: LegalDocumentCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 legalV1DocumentsCreate<TData = LegalDocumentResponseV1>(legalDocumentCreateRequestV1Request: LegalDocumentCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  legalV1DocumentsCreate<TData = LegalDocumentResponseV1>(
    legalDocumentCreateRequestV1Request: LegalDocumentCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/legal/documents/`,
      legalDocumentCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/legal/documents/`,
      legalDocumentCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/legal/documents/`,
      legalDocumentCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Public: the privacy policy must be available at all times (Ley 21.719, art. 14 ter). Each one is null while it was never published. No token is needed; a logged-in client sends its own, and an invalid or expired one is a 401.
 * @summary The current terms of service and privacy policy.
 */
 legalV1DocumentsCurrentRetrieve<TData = CurrentLegalDocumentsResponseV1>( options?: HttpClientBodyOptions): Observable<TData>;
 legalV1DocumentsCurrentRetrieve<TData = CurrentLegalDocumentsResponseV1>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 legalV1DocumentsCurrentRetrieve<TData = CurrentLegalDocumentsResponseV1>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  legalV1DocumentsCurrentRetrieve<TData = CurrentLegalDocumentsResponseV1>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/legal/documents/current/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/legal/documents/current/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/legal/documents/current/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type LegalV1AcceptancesListClientResult = NonNullable<CursorPaginatedLegalAcceptanceResponseV1>
export type LegalV1AcceptancesCreateClientResult = NonNullable<LegalAcceptanceResponseV1>
export type LegalV1AcceptancesStatusRetrieveClientResult = NonNullable<LegalAcceptanceStatusResponseV1>
export type LegalV1DocumentsListClientResult = NonNullable<CursorPaginatedLegalDocumentResponseV1>
export type LegalV1DocumentsCreateClientResult = NonNullable<LegalDocumentResponseV1>
export type LegalV1DocumentsCurrentRetrieveClientResult = NonNullable<CurrentLegalDocumentsResponseV1>
